import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var ClaimsIcon = createIcon({
  displayName: 'ClaimsIcon',
  viewBox: '0 0 15 18',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M5.47998 10.7001C5.70775 11.016 6.00867 11.2719 6.35698 11.4461C6.7053 11.6203 7.09062 11.7074 7.47998 11.7001C8.71998 11.7001 9.72998 10.9401 9.72998 10.0101C9.72998 9.08011 8.72998 8.32011 7.47998 8.32011C6.22998 8.32011 5.22998 7.57011 5.22998 6.63011C5.22998 5.69011 6.22998 4.95011 7.47998 4.95011C7.86501 4.93708 8.24755 5.01654 8.59554 5.18183C8.94352 5.34713 9.24681 5.59343 9.47998 5.90011",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.6599V12.7799",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.78003V4.91003",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 17.25V2.75C14.25 2.21957 14.0393 1.71086 13.6642 1.33579C13.2891 0.960714 12.7804 0.75 12.25 0.75H2.75C2.21957 0.75 1.71086 0.960714 1.33579 1.33579C0.960714 1.71086 0.75 2.21957 0.75 2.75V17.25L3 16.13L5.25 17.25L7.5 16.13L9.75 17.25L12 16.13L14.25 17.25Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }))
});
//# sourceMappingURL=Claims.js.map